import "./App.scss";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { permissionAlert } from "./alerts/alerts";

import LoadingModal from "./components/loadingModal/LoadingModal";
import Rotes from "./Rotes";
import Sidebar from "./components/sidebar/Sidebar";
import Header from "./components/header/Header";

function App() {
    const location = useLocation();

    const isSomeQueryPending = useSelector((state) =>
        Object.values(state.velmartAPI.queries).some((query) => query.status === "pending")
    );

    // const isPermissions = useSelector((state) => Object.values(state.velmartAPI.mutations)).some(
    //     (mutation) => mutation?.error?.status === 403
    // );

    // const isGlobalErrors = useSelector((state) => Object.values(state.velmartAPI.mutations)).some(
    //     (mutation) => mutation?.error?.status === 422
    // );

    // const errorMasage = useSelector((state) => Object.values(state.velmartAPI.mutations)).find((mutation) => {
    //     return mutation?.error?.status === 422;
    // });

    // useEffect(() => {
    //     if (isGlobalErrors) {
    //         alert(errorMasage.error.data.message);
    //     }
    // }, [isGlobalErrors]);

    // useEffect(() => {
    //     if (isPermissions) {
    //         permissionAlert();
    //     }
    // }, [isPermissions]);

    if (location.pathname === "/login" || location.pathname === "/") {
        document.body.style.backgroundColor = "#ee3124";
        return (
            <>
                {isSomeQueryPending && <LoadingModal />} <Rotes />
            </>
        );
    } else {
        document.body.style.backgroundColor = "#F6F6F7";
    }

    return (
        <div className="global-container">
            <div className="content">
                <Sidebar />
                <div className="content__wrapper">
                    <Header />
                    {isSomeQueryPending && <LoadingModal />} <Rotes />
                </div>
            </div>
        </div>
    );
}

export default App;
